// extracted by mini-css-extract-plugin
export default {"stickyHeader":"sticky-header_stickyHeader__9x5S-"};